module.exports = __webpack_public_path__ + "img/imemo_icon.082c153e.png";